import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "c1bab4a1-3dfd-4201-8ddb-bc68c9b01286", // Đảm bảo thay bằng Client ID thật  c1bab4a1-3dfd-4201-8ddb-bc68c9b01286 |  820e21e4-8c6d-4498-b9f4-41335d1f708a
    authority: "https://login.microsoftonline.com/edee465d-19d3-4bbe-a596-2f82ee8069fa", // Hoặc tenant ID cụ thể
    redirectUri: "https://vanphong.hkoil.org", // Đổi theo ứng dụng của bạn https://daily.hkoil.org | http://localhost:8080
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

// ✅ Đảm bảo gọi `initialize()` trước khi dùng MSAL
async function initializeMsal() {
  await msalInstance.initialize();
}

export { msalInstance, initializeMsal };
